// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"9f437ad1","703":"d9e9edcb","729":"2b94a9e9"}[chunkId] + ".chunk.js";
};